import { css } from "@emotion/react";
import { rem } from "polished";
import React from "react";
import { useTranslation } from "react-i18next";

import Modal from "../Modal";
import StepSupply from "./SupplyStepSupply";

const SupplyModal = () => {
  const { t } = useTranslation();
  return (
    <Modal
      boxCss={css`
        width: ${rem(700)};
      `}
      title={t("modal.supply.title")}
      onBackgroundClickPath="/account"
    >
      <StepSupply />
    </Modal>
  );
};

export default SupplyModal;
